import { useState } from "react"
import PropTypes from "prop-types"
import { isFunction } from "lodash"
import classNames from "classnames"
import { Switch } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"
import { formatLongDate } from "helpers/formatters/dates"
import { ABSOLUTE_DATE_PROPTYPE } from "helpers/shareMyView"
import "./style.scss"

function formatAbsoluteDate({ date, startDate, endDate }) {
  if (date) {
    return formatLongDate(date)
  }
  return `${formatLongDate(startDate)} - ${formatLongDate(endDate)}`
}

function SharedDate({ relativeDate, absoluteDate, onToggle }) {
  const [isAbsolute, setIsAbsolute] = useState(false)

  const handleToggle = ({ currentTarget: { checked } }) => {
    setIsAbsolute(checked)
    if (isFunction(onToggle)) {
      onToggle(checked)
    }
  }

  return <div className="modules_share-my-view_components_shared-date">
    <h3>
      Share type
      <OPTooltip
        slotProps={{ popper: { disablePortal: true } }}
        title={<>This link, <i>when opened</i>, will display dates either as the selected time window, or with static dates.</>}
        placement="right"
      >
        <InfoOutlined className="info-icon" />
      </OPTooltip>
    </h3>
    <div className="toggle">
      <div className={classNames("label", { active: !isAbsolute })}>
        <div className="title">Time Window</div>
        <div className="value">{relativeDate}</div>
      </div>
      <Switch onChange={handleToggle} checked={isAbsolute} />
      <div className={classNames("label", { active: isAbsolute })}>
        <div className="title">Static</div>
        <div className="value">{formatAbsoluteDate(absoluteDate)}</div>
      </div>
    </div>
  </div>
}

SharedDate.propTypes = {
  relativeDate: PropTypes.string,
  absoluteDate: ABSOLUTE_DATE_PROPTYPE,
  onToggle: PropTypes.func.isRequired,
}

export default SharedDate
